/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {SendInviteModel} from "../../models/send-invite-model";
import {InviteLinkModel} from "../../models/invite-link-model";

export interface QuestionnaireSendInvitesPostParams {
    questionnaireGuid: string;
    body?: SendInviteModel
}

export function questionnaireSendInvitesPost(http: HttpClient, rootUrl: string, params: QuestionnaireSendInvitesPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InviteLinkModel[]>> {
    const rb = new RequestBuilder(rootUrl, questionnaireSendInvitesPost.PATH, 'post');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }
    if (params) {
        rb.path('guid', params.questionnaireGuid, {"style":"simple"});
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<InviteLinkModel[]>;
        })
    );
}

questionnaireSendInvitesPost.PATH = '/api/v1/questionnaires/{guid}/send-invites';
